import { LongevityAreaId } from '../../../alerts/longevity-alerts/longevity-alerts.model';
import { LongevityAnswerSection, LongevityAnswerView } from './longevity-request-assessments.model';

/** Icona per area, identica a `LONGEVITY_AREA_ICONS` della Web App (classi `.i-*` nello scss del componente). */
export const LONGEVITY_AREA_ICONS: Record<LongevityAreaId, string> = {
  BODY: 'i-heart',
  MIND: 'i-light-bulb',
  FINANCE: 'i-banknotes',
  COMMUNITY: 'i-user-group',
};

export interface LongevitySectionView {
  title: string;
  /** Classe `.i-*` (Heroicons via mask-image, stessa di `LONGEVITY_AREA_ICONS`/`LONGEVITY_CONTEXT_ICON` nella Web App). */
  icon: string;
  answers: LongevityAnswerView[];
}

/**
 * Titolo e icona di ogni sezione, come nella Web App: il Contesto (F1-F2, domande senza area), poi una
 * sezione per area. Niente cervello tra le Heroicons: la Mente usa la lampadina.
 */
const SECTION_INFO: Record<LongevityAnswerSection, { title: string; icon: string }> = {
  CONTEXT: { title: 'Contesto', icon: 'i-clipboard-document-list' },
  MIND: { title: 'Mente', icon: LONGEVITY_AREA_ICONS.MIND },
  BODY: { title: 'Corpo', icon: LONGEVITY_AREA_ICONS.BODY },
  COMMUNITY: { title: 'Spazio collettivo', icon: LONGEVITY_AREA_ICONS.COMMUNITY },
  FINANCE: { title: 'Longevità finanziaria', icon: LONGEVITY_AREA_ICONS.FINANCE },
  // Senza questionario non si sa a che area appartiene ogni risposta.
  OTHER: { title: 'Risposte', icon: 'i-document' },
};

/**
 * Risposte del dettaglio -> sezioni, nell'ordine in cui il backend manda le domande: ogni cambio di area
 * apre una sezione nuova (il Contesto per le domande senza area). Il raggruppamento segue quindi il
 * questionario e non un elenco fisso di domande.
 */
export function groupAnswersBySection(answers: LongevityAnswerView[]): LongevitySectionView[] {
  const sections: (LongevitySectionView & { id: LongevityAnswerSection })[] = [];
  for (const answer of answers) {
    const last = sections[sections.length - 1];
    if (last && last.id === answer.area) {
      last.answers.push(answer);
    } else {
      sections.push({ id: answer.area, ...SECTION_INFO[answer.area], answers: [answer] });
    }
  }
  return sections.map(({ title, icon, answers: sectionAnswers }) => ({ title, icon, answers: sectionAnswers }));
}
